export interface CountryAreaChoice {
  raw: string | null;
  verbose: string | null;
}

export interface AddressValidationRulesData {
  requiredFields: string[];
  countryAreaChoices: CountryAreaChoice[];
  countryAreaType: string;
  postalCodeType: string;
  cityType: string;
  cityChoices: CountryAreaChoice[];
}

export type CountryAreaLabelKey =
  | 'state'
  | 'province'
  | 'prefecture'
  | 'district'
  | 'postal'
  | 'zip'
  | 'region'
  | 'county';

const COUNTRY_AREA_LABEL_KEYS: Record<string, CountryAreaLabelKey> = {
  state: 'state',
  province: 'province',
  prefecture: 'prefecture',
  district: 'district',
  postal: 'postal',
  zip: 'zip',
  region: 'region',
  county: 'county',
};

export function getCountryAreaLabelKey(
  countryAreaType: string | null | undefined
): CountryAreaLabelKey {
  if (countryAreaType && countryAreaType in COUNTRY_AREA_LABEL_KEYS) {
    return COUNTRY_AREA_LABEL_KEYS[countryAreaType];
  }
  return 'province';
}

export function isCountryAreaRequired(requiredFields: string[] | undefined): boolean {
  return requiredFields?.includes('countryArea') ?? false;
}

const COUNTRY_AREA_REQUIRED_FALLBACK = new Set(['US', 'CA', 'AU', 'JP', 'IT', 'ES']);

/** Fail-closed when Saleor rules are unavailable; optional only when rules explicitly omit countryArea. */
export function isCountryAreaRequiredFallback(countryCode: string): boolean {
  return COUNTRY_AREA_REQUIRED_FALLBACK.has(countryCode.trim().toUpperCase());
}

export function toCountryAreaOptions(
  choices: CountryAreaChoice[] | undefined
): Array<{ value: string; label: string }> {
  if (!choices?.length) {
    return [];
  }

  return choices
    .filter((choice): choice is { raw: string; verbose: string } =>
      Boolean(choice.raw && choice.verbose)
    )
    .map((choice) => ({
      value: choice.raw,
      label: choice.verbose,
    }));
}
